// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".GlobalLoadingIndicator-wrapper-2fIJh {\n  display: none;\n  opacity: 0;\n  transition-property: display, opacity;\n  transition-delay: 0.1s;\n  transition-duration: 0.2s;\n  transition-behavior: allow-discrete;\n}\n.GlobalLoadingIndicator-wrapperActive-10vXM {\n  display: block;\n  opacity: 1;\n  transition-delay: 0.3s;\n  @starting-style {\n    opacity: 0;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "GlobalLoadingIndicator-wrapper-2fIJh",
	"wrapperActive": "GlobalLoadingIndicator-wrapperActive-10vXM GlobalLoadingIndicator-wrapper-2fIJh"
};
module.exports = exports;
